import React from 'react';
import ReactDOM from 'react-dom';
import TripBoardButton from './components/TripBoardButton/TripBoardButton';

// This function is here so we can pull the ReactDOM.render logic out of stab-hit and PDP.
function renderTripBoardButton(element, props) {
    return ReactDOM.render(<TripBoardButton {...props} />, element);
}

export default renderTripBoardButton;
